module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-mobile-411x93.2d66a99b.jpg";